import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import EmptyState from '@atlaskit/empty-state';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import TwoFaIllustration from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/software/components/twofa/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import authErrorImg from '../../common/assets/authentication-error.svg';
import { ErrorDisplay } from '../../common/ui/error-display/index.tsx';
import { messages } from './messages.tsx';

type DispatchProps = {
	// eslint-disable-next-line jira/react/handler-naming
	login: () => void;
};

const ErrorImage = () =>
	fg('move_issue_view_assets_into_central_location') ? (
		<Box
			xcss={[
				imageWrapperStyles,
				fg('replace_error_display_with_empty_state') && illustrationStyles,
			]}
		>
			<TwoFaIllustration width={160} height={134} alt="" />
		</Box>
	) : (
		<Image src={authErrorImg} alt="" />
	);

export const AuthenticationErrorViewLegacy = (props: DispatchProps) => {
	const intl = useIntl();
	return fg('replace_error_display_with_empty_state') ? (
		<EmptyState
			testId="issue-view-errors.ui.authentication-error-view-legacy.authentication-error-view"
			header={intl.formatMessage(
				expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
					? messages.authErrorHeaderIssueTermRefresh
					: messages.authErrorHeader,
			)}
			renderImage={() => <ErrorImage />}
			primaryAction={
				<Button
					// @ts-expect-error - TS2322 - Type '{ children: string; externalId: string; appearance: "primary"; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
					externalId="issue.login"
					appearance="primary"
					onClick={props.login}
					interactionName="auto-generated.jira-issue-view-errors.ui.authentication-error-view-legacy.button"
				>
					{intl.formatMessage(messages.authButton)}
				</Button>
			}
		/>
	) : (
		<ErrorDisplay
			header={intl.formatMessage(
				expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
					? messages.authErrorHeaderIssueTermRefresh
					: messages.authErrorHeader,
			)}
			image={<ErrorImage />}
		>
			<Button
				// @ts-expect-error - TS2322 - Type '{ children: string; externalId: string; appearance: "primary"; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
				externalId="issue.login"
				appearance="primary"
				onClick={props.login}
				interactionName="auto-generated.jira-issue-view-errors.ui.authentication-error-view-legacy.button"
			>
				{intl.formatMessage(messages.authButton)}
			</Button>
		</ErrorDisplay>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Image = styled.img({
	width: '160px',
	marginBottom: token('space.200'),
});

const imageWrapperStyles = xcss({
	marginBottom: 'space.200',
});

const illustrationStyles = xcss({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});
